// CC1 COPY
// See: https://docs.google.com/spreadsheets/d/1ha95WQWFFzOKA8GeNUH4kNPddIaiBrgxNd-2sOK1uZ4/edit
export const MEDICAL_CCS1_COPY = {
  1: {
    title: "Infectious Diseases",
    shortName: "Infectious",
    tooltip:
      "Conditions relating to damage or disruption of the body's organs, tissues, or processes due to the invasion of microorganisms"
  },
  2: {
    title: "Cancer",
    shortName: "Cancer",
    tooltip:
      "Conditions relating to abnormal cell growth that can spread into other issues in the body"
  },
  3: {
    title: "Metabolic Diseases",
    shortName: "Metabolic",
    tooltip:
      "Conditions affecting the body's ability to perform the biochemical processes critical for organs to function, such as converting nutrients to energy or producing hormones vital for development"
  },
  4: {
    title: "Blood Diseases",
    shortName: "Blood",
    tooltip:
      "Conditions affecting one or multiple parts of the blood (e.g., red blood cells, white blood cells, platelets, plasma) and impact the ability for the blood to serve the body's needs"
  },
  5: {
    title: "Behavioral Health",
    shortName: "Behavioral Health",
    tooltip: "Conditions relating to emotional, psychological, and social health"
  },
  6: {
    title: "Neurological Diseases",
    shortName: "Neurological",
    tooltip:
      "Conditions relating to the brain, spinal cord, and nerves that make up the central nervous system"
  },
  7: {
    title: "Cardiovascular Diseases",
    shortName: "Cardiovascular",
    tooltip:
      "Conditions relating to the cardiovascular system, the group of organs and tissues that circulate blood throughout the body"
  },
  8: {
    title: "Lung Diseases",
    shortName: "Lung",
    tooltip:
      "Conditions relating to the lungs and other parts of the respiratory system, which distributes oxygen throughout the body"
  },
  9: {
    title: "Digestive Diseases",
    shortName: "Digestive",
    tooltip:
      "Conditions relating to the digestive system, which breaks down nutrients into forms the body uses to function"
  },
  10: {
    title: "Genitourinary Diseases",
    shortName: "Genitourinary",
    tooltip:
      "Conditions relating to the organs, tissues, and processes of the reproductive and urinary systems"
  },
  11: {
    title: "Maternity & Fertility",
    shortName: "Maternity & Fertility",
    tooltip:
      "Conditions and complications relating to pregnancy, including contraceptive management, childbirth, and the post-partum period"
  },
  12: {
    title: "Dermatological Diseases",
    shortName: "Dermatological",
    tooltip: "Conditions relating to the skin"
  },
  13: {
    title: "Musculoskeletal Conditions",
    shortName: "Musculoskeletal",
    tooltip:
      "Conditions relating to the body's ability to move (e.g., muscles, ligaments, tendons) and shield its internal organs and tissues (e.g., skeleton) "
  },
  14: {
    title: "Congenital Conditions",
    shortName: "Congenital",
    tooltip: "Conditions that are present at birth, or develop shortly thereafter"
  },
  15: {
    title: "Perinatal Complications",
    shortName: "Perinatal",
    tooltip: "Conditions relating to babies during pregnancy, birth, and the weeks following birth"
  },
  16: {
    title: "Injuries & Poisonings",
    shortName: "Injuries & Poisonings",
    tooltip:
      "Conditions relating to damage or harm to the body caused by external factors such as forces (e.g., accident, weapon) or substances (e.g., poison, drugs)"
  },
  17: {
    title: "Ill-defined Conditions",
    shortName: "Ill-defined",
    tooltip:
      "Includes diagnosis codes for general medical exams, screenings, preventive health, and equipment, as well as conditions for which a diagnostic workup is still taking place before making a diagnosis (e.g., lab tests and radiology need to be done)."
  },
  18: {
    title: "Unclassified Conditions",
    shortName: "Unclassified",
    tooltip: `Includes over 7,000 diagnosis codes that describe some clinical conditions like sleep disorders and adverse effects of medical drugs, as well as "cause codes" that outline additional details regarding the development of an injury or condition (e.g., place of occurrence, whether someone was struck by an object, caused by a transportation accident, exposure to the natural environment, firearms, burns, poison, falling)`
  }
};

// CCS2 COPY
// See https://docs.google.com/spreadsheets/d/1ha95WQWFFzOKA8GeNUH4kNPddIaiBrgxNd-2sOK1uZ4/edit#gid=1246330698
export const MEDICAL_CCS2_COPY = {
  "1.1": {
    title: "Bacterial infection",
    tooltip:
      "Common examples include strep throat, UTIs, pneumococcal pneumonia, and bacterial food poisoning. Bacterial infections are most often treated with antibiotics, though severe cases may require hospitalization and treatment with intravenous antibiotics."
  },
  "1.2": {
    title: "Mycoses",
    tooltip:
      "A fungal infection. Common examples include athlete’s foot, jock itch, ringworm, and yeast infections.  Severe cases can cause infections in the blood and lung."
  },
  "1.3": {
    title: "Viral infection",
    tooltip: "Common examples include influenza, the common cold, chickenpox, and HIV."
  },
  "1.4": {
    title: "Other infections; including parasitic",
    tooltip:
      "Common examples include Lyme disease, lice, malaria, Chagas' disease, foodborne parasitic infections (Toxoplasmosis), and some sexually transmitted infections (Trichomoniasis)."
  },
  "1.5": {
    title: "Immunizations and screening for infectious disease",
    tooltip:
      "Includes immunizations and screenings for a wide range of infections, such as sexually transmitted infections, chicken pox, rabies, and staph infections."
  },
  "2.1": {
    title: "Colorectal cancer",
    tooltip: "Cancer that affects the colon or the rectum."
  },
  "2.10": {
    title: "Cancer of lymphatic and hematopoietic tissue",
    tooltip: "Cancer that affects the blood, bone marrow, and lymphatic system."
  },
  "2.11": {
    title: "Cancer; other primary",
    tooltip:
      "Includes diagnosis codes for almost 300 other types of cancer, including cancers of the thyroid, brain, eye, and connective and soft tissue."
  },
  "2.12": {
    title: "Secondary malignancies",
    tooltip:
      "A new primary cancer that occurs in a person who has previously had a different cancer in the past."
  },
  "2.13": {
    title: "Malignant neoplasm without specification of site",
    tooltip:
      "A cancerous tumor within the nervous or hormonal systems and can occur anywhere in the body."
  },
  "2.14": {
    title: "Neoplasms of unspecified nature or uncertain behavior",
    tooltip:
      "A tumor with no definitive diagnosis at the time of the member's encounter with a provider"
  },
  "2.15": {
    title: "Maintenance chemotherapy; radiotherapy",
    tooltip:
      "The treatment of cancer with medication, typically following an initial round of treatment"
  },
  "2.16": {
    title: "Benign neoplasms",
    tooltip:
      "Tumors that are noncancerous. They may grow large but do not spread to other parts of the body."
  },
  "2.2": {
    title: "Other gastrointestinal cancer",
    tooltip:
      "Cancer that affects the gastrointestinal tract and other organs in the digestive system. This can include the stomach, esophagus, pancreas, colon, rectum, anus, gallbladder, and small intestine."
  },
  "2.3": {
    title: "Cancer of bronchus; lung",
    tooltip: "Cancer that affects the lungs or respiratory tract"
  },
  "2.4": {
    title: "Cancer of skin",
    tooltip: ""
  },
  "2.5": {
    title: "Cancer of breast",
    tooltip: ""
  },
  "2.6": {
    title: "Cancer of uterus and cervix",
    tooltip: ""
  },
  "2.7": {
    title: "Cancer of ovary and other female genital organs",
    tooltip: ""
  },
  "2.8": {
    title: "Cancer of male genital organs",
    tooltip: ""
  },
  "2.9": {
    title: "Cancer of urinary organs",
    tooltip: ""
  },
  "3.1": {
    title: "Thyroid disorders",
    tooltip:
      "Disorders that affect the thyroid gland, which manufactures hormones that regulate the body's metabolism."
  },
  "3.10": {
    title: "Immunity disorders",
    tooltip:
      "Disorders that impair the immune system, making it harder for the body to fight off disease and infection.  Examples include overreactions of the immune system that result in inflammation, and immune deficiency."
  },
  "3.11": {
    title: "Other nutritional; endocrine; and metabolic disorders",
    tooltip:
      "A wide range of diagnoses pertaining to body weight, nutritional intake, and development and functioning of bones and organs.  A common example is morbid obesity."
  },
  "3.2": {
    title: "Diabetes mellitus without complication",
    tooltip:
      "A condition in which the body has high blood sugar because it is either not making enough insulin, or not effectively using the insulin it has."
  },
  "3.3": {
    title: "Diabetes mellitus with complications",
    tooltip:
      "A condition in which the body has high blood sugar because it is either not making enough insulin, or not effectively using the insulin it has. Having high blood sugar can damage other organs and tissues, increasing risk for other complications. Examples of complications include heart disease, hearing loss, skin damage, and depression."
  },
  "3.4": {
    title: "Other endocrine disorders",
    tooltip:
      "A wide range of disorders affecting the endocrine system, which releases hormones directly into the bloodstream that regulate bodily functions, mood, growth, and development.  Examples include under- or overproduction of hormones like testosterone."
  },
  "3.5": {
    title: "Nutritional deficiencies",
    tooltip: "A condition in which the body does not absorb enough vitamins and minerals from food"
  },
  "3.6": {
    title: "Disorders of lipid metabolism",
    tooltip:
      "A condition in which the blood has high levels of low-density lipoprotein (LDL) cholesterol, and fats (triglycerides), or both. This condition increases risk for heart disease. "
  },
  "3.7": {
    title: "Gout and other crystal arthropathies",
    tooltip:
      "Crystal arthropathies are joint disorders caused by a buildup of crystals in joints and the tissues around them. Gout is a common type of this condition caused by a buildup of a specific crystal, uric acid, and often affects the joint at the base of the big toe."
  },
  "3.8": {
    title: "Fluid and electrolyte disorders",
    tooltip:
      "Conditions in which the body's fluid or electrolyte levels are too high or too low. Electrolytes are vital to major functions in the body, from allowing absorption of vital fluids like water to regulating muscle contractions.  Examples of electrolytes include calcium, chloride, magnesium, phosphate, potassium, and sodium."
  },
  "3.9": {
    title: "Cystic fibrosis",
    tooltip:
      "A genetic condition causing severe damage to the lungs and digestive system. The body creates a thick, sticky, mucus in the organs that can affect the lungs, pancreas, liver, and intestines."
  },
  "4.1": {
    title: "Anemia",
    tooltip: "A condition in which the body lacks enough healthy red blood cells"
  },
  "4.2": {
    title: "Coagulation and hemorrhagic disorders",
    tooltip:
      "Bleeding disorders that disrupt the body's ability to control blood clotting, either resulting in too much or too little clotting"
  },
  "4.3": {
    title: "Diseases of white blood cells",
    tooltip:
      "Conditions that affect the body's white blood cells, which help the body fight infections. Low white blood cell counts increase the body's risk for any illness or infection."
  },
  "4.4": {
    title: "Other hematologic conditions",
    tooltip:
      "Disorders of the blood and blood-forming organs.  An example is a disease where the blood has an increased volume of red blood cells, slowing blood flow due to increased thickness of blood."
  },
  "5.1": {
    title: "Adjustment disorders",
    tooltip:
      "A short-term condition when a person is having difficulty managing or adjusting to a particular identifiable source of stress"
  },
  "5.10": {
    title: "Schizophrenia and other psychotic disorders",
    tooltip:
      "A condition in which a person may not be able to distinguish between reality and hallucinations or delusions"
  },
  "5.11": {
    title: "Alcohol-related disorders",
    tooltip: "Addiction or abuse of alcohol"
  },
  "5.12": {
    title: "Substance-related disorders",
    tooltip: "Addiction or abuse of drugs"
  },
  "5.13": {
    title: "Suicide and intentional self-inflicted injury",
    tooltip: "Thoughts or actions to related to self harm or ending one's own life"
  },
  "5.14": {
    title: "Screening and history of mental health and substance abuse codes",
    tooltip:
      "Includes a variety of mental health and substance abuse diagnoses.  Examples include having a personal history of nicotine dependence and general psychiatric examination."
  },
  "5.15": {
    title: "Miscellaneous mental disorders",
    tooltip:
      "Includes a variety of mental health conditions.  Examples include transsexualism, or experiencing distress with the sex and gender assigned at birth, as well as eating disorders that are not classified as anorexia or bulimia."
  },
  "5.2": {
    title: "Anxiety disorders",
    tooltip:
      "An emotional disorder relating to the body's natural response to stress, involving feelings of fear, worry and apprehension. Anxiety can be a part of several other disorders, including panic disorders, phobias, obsessive-compulsive disorders, and post-traumatic stress disorders. "
  },
  "5.3": {
    title: "Attention deficit conduct and disruptive behavior disorders",
    tooltip:
      "Diagnosed individuals may be overly active, struggle to focus, and/or have difficulty controlling impulsive behaviors."
  },
  "5.4": {
    title: "Delirium dementia and amnestic and other cognitive disorders",
    tooltip:
      "Disorders that include memory loss, mental confusion, or emotional disruption. This can impact thinking, language, judgement, behavior, and memory."
  },
  "5.5": {
    title: "Developmental disorders",
    tooltip:
      "A range of severe, chronic, mental disabilities that begin in childhood and can impact a person through their lifetime. Examples include language disorders that make it difficult for individuals to communicate, as well as delayed development of motor functions and educational skills."
  },
  "5.6": {
    title: "Disorders usually diagnosed in infancy childhood or adolescence",
    tooltip:
      "Includes a variety of disorders diagnosed during growth and development, with the most common type being autism."
  },
  "5.7": {
    title: "Impulse control disorders not elsewhere classified",
    tooltip:
      "Disorders involving an inability to control an urge or desire, particularly one that is illegal or conflicts with social norms or the rights of others.  Includes six main disorders - pathological gambling, pyromania, kleptomania, trichotillomania, intermittent explosive disorder, and homicidal ideations - in addition to others."
  },
  "5.8": {
    title: "Mood disorders",
    tooltip:
      "A mental disorder that affects a person's emotional state for several weeks or longer. Common mood disorders include depression and bipolar disorder."
  },
  "5.9": {
    title: "Personality disorders",
    tooltip:
      "Mental health conditions that can affect the way people think, feel and behave. Examples include schizoid, narcissistic, and obsessive-compulsive personality disorders."
  },
  "6.1": {
    title: "Central nervous system infection",
    tooltip:
      "The central nervous system is mainly made up of the brain and spinal cord.  Infections are most commonly caused by bacteria and viruses, causing symptoms like inflammation of the brain or the membranes and fluids surrounding it."
  },
  "6.2": {
    title: "Hereditary and degenerative nervous system conditions",
    tooltip:
      "Conditions resulting from the loss of function in the neurons and the central nervous system, inhibiting the body's core functions.  Some examples include multiple sclerosis and Parkinson's disease."
  },
  "6.3": {
    title: "Paralysis",
    tooltip: "The inability to move one or more muscles"
  },
  "6.4": {
    title: "Epilepsy; convulsions",
    tooltip:
      "A chronic disorder caused by excessive activity in the brain that presents recurring seizures."
  },
  "6.5": {
    title: "Headache; including migraine",
    tooltip:
      "A headache is pain in the face, neck, or head. Migraines are a common type of headache, marked by moderate to high severity, reoccurrence, sensory sensitivity, and often specific to one side of the head."
  },
  "6.6": {
    title: "Coma; stupor; and brain damage",
    tooltip:
      "A prolonged state of unconsciousness caused by injury or illness that damages the brain"
  },
  "6.7": {
    title: "Eye disorders",
    tooltip:
      "Conditions affecting the functioning and health of the eye.  Examples include cataracts (cloudy formations in the lens of the eye), retinal detachments, glaucoma (pressure and damage to the optic nerve), blindness, inflammation, and a variety of other eye disorders."
  },
  "6.8": {
    title: "Ear conditions",
    tooltip:
      "Conditions affecting the functioning and health of the ear.  Examples include ear infections, conditions associated with dizziness or vertigo, hearing loss, and other conditions affecting the parts of the ear."
  },
  "6.9": {
    title: "Other nervous system disorders",
    tooltip:
      "Includes a variety of disorders impacting the system of cells, nerves, and organs that control the body's functions and processes"
  },
  "7.1": {
    title: "Hypertension",
    tooltip:
      "High blood pressure, which can cause other diseases if persistent for a long-term period"
  },
  "7.2": {
    title: "Diseases of the heart",
    tooltip:
      "Conditions affecting the functioning and health of the heart.  Examples include heart attack, heart failure, irregular heartbeat, plaque buildup limiting blood supply to the heart, heart valve disorders, and inflammation of the heart and surrounding tissues."
  },
  "7.3": {
    title: "Cerebrovascular disease",
    tooltip:
      "Includes a variety of conditions that affect the circulation of blood in the brain, limiting or preventing the brain from receiving sufficient oxygen and nutrients"
  },
  "7.4": {
    title: "Diseases of arteries; arterioles; and capillaries",
    tooltip:
      "Conditions affecting the circulation of blood in the body.  Examples include blood clots, swollen arteries, and blockages to the blood vessels."
  },
  "7.5": {
    title: "Diseases of veins and lymphatics",
    tooltip:
      "Includes inflammation and blockages in the veins impairing blood circulation, as well as those in the vessels of the lymphatic system impairing the body's ability to filter out waste and fight infection"
  },
  "8.1": {
    title: "Respiratory infections",
    tooltip:
      "Infections that impair the organs and processes involved in the respiratory system that allow breathing.  Examples include the flu, bronchitis, tonsillitis, and pneumonia."
  },
  "8.2": {
    title: "Chronic obstructive pulmonary disease and bronchiectasis",
    tooltip:
      "Chronic obstructive pulmonary disease, also known as COPD, includes a group of lung diseases and is characterized by the obstruction of airflow from the lungs, resulting in shortness of breath, difficulty breathing, and cough. \nBronchiectasis is a condition where the airways in the lungs are damaged and enlarged, allowing mucus to build up and increasing the chance of infection and breathing difficulties."
  },
  "8.3": {
    title: "Asthma",
    tooltip:
      "Asthma is a chronic condition where the airways of the lungs become inflamed and narrow, making breathing difficult."
  },
  "8.4": {
    title: "Aspiration pneumonitis; food/vomitus",
    tooltip:
      "An infection in the lungs caused when a large amount of food, stomach acid, or saliva are inhaled."
  },
  "8.5": {
    title: "Pleurisy; pneumothorax; pulmonary collapse",
    tooltip:
      "Conditions affecting the lining between the lung and the chest (pleura) or in the space surrounding the lung and heart. Includes infections, scarring, and collapsed lungs."
  },
  "8.6": {
    title: "Respiratory failure; insufficiency; arrest (adult)",
    tooltip:
      "Conditions that occur when the lungs cannot get sufficient oxygen into the blood, or there is too much carbon dioxide in the blood."
  },
  "8.7": {
    title: "Lung disease due to external agents",
    tooltip:
      "Conditions causing inflammation of lung tissue due to the inhalation of dust or other foreign particles (e.g., textiles, toxic fumes, plant matter).  Sometimes called occupational asthma, these conditions often cause difficulty breathing, coughing, and scarring of lung tissue. "
  },
  "8.8": {
    title: "Other lower respiratory disease",
    tooltip:
      "Infections occurring in the respiratory system below the voice box, such as pneumonia, bronchitis, and abnormalities of breathing.  Common symptoms include cough and shortness of breath."
  },
  "8.9": {
    title: "Other upper respiratory disease",
    tooltip:
      "Infections occurring in the upper respiratory system, which includes the voice box, throat, nose, and mouth.  Examples include nasal congestion and sneezing due to pollen allergies and having a deviated nasal septum."
  },
  "9.1": {
    title: "Intestinal infection",
    tooltip:
      "Infection in the intestines most commonly caused by bacteria, viruses, or parasites.  Examples include the stomach flu, food poisoning, and cholera."
  },
  "9.10": {
    title: "Gastrointestinal hemorrhage",
    tooltip: "Bleeding that occurs in the digestive tract, anywhere from the mouth to the rectum.  "
  },
  "9.11": {
    title: "Noninfectious gastroenteritis",
    tooltip:
      "Inflammation of the stomach, small intestine, or colon that is not caused by an infection.  These conditions may be induced by stress, food sensitivity, medication, or other noninfectious causes.  Symptoms can include stomach cramps, diarrhea, nausea, or vomiting."
  },
  "9.12": {
    title: "Other gastrointestinal disorders",
    tooltip:
      "Includes a variety of conditions affecting the digestive tract, including diarrhea, constipation, irritable bowel syndrome, and Celiac disease."
  },
  "9.2": {
    title: "Disorders of teeth and jaw",
    tooltip:
      "Conditions affecting the growth and function of the teeth and jaw.  Examples include jaw pain, a cracked tooth, underdeveloped jaw bones, or failure for a tooth to fully emerge from the gums. "
  },
  "9.3": {
    title: "Diseases of mouth; excluding dental",
    tooltip:
      "A variety of conditions affecting the mouth, including the tongue and salivary glands.  Examples include mouth inflammation or sores, and cysts in the salivary glands due to biting the lip."
  },
  "9.4": {
    title: "Upper gastrointestinal disorders",
    tooltip:
      "Disorders affecting the upper gastrointestinal tract: esophagus, stomach, and upper section of the small intestine. Examples include acid reflux and inflammation of the stomach lining."
  },
  "9.5": {
    title: "Abdominal hernia",
    tooltip: "The bulging of a tissue or organ through an abnormal exit in the abdominal wall"
  },
  "9.6": {
    title: "Lower gastrointestinal disorders",
    tooltip:
      "Disorders affecting the lower gastrointestinal system including the lower portion of the small intestine, large intestine, rectum, and anus. Examples include appendicitis and Crohn's disease."
  },
  "9.7": {
    title: "Biliary tract disease",
    tooltip:
      "Diseases affecting the production, storage, or transportation of bile, a fluid required for digestion and produced by the liver.  Includes a variety of diseases that affect the gallbladder, which stores bile, and the bile ducts and other tissues involved in transporting bile from the liver to the small intestine."
  },
  "9.8": {
    title: "Liver disease",
    tooltip:
      "Conditions impacting the liver, the organ that detoxifies the body and supports digestion."
  },
  "9.9": {
    title: "Pancreatic disorders (not diabetes)",
    tooltip:
      "Conditions that affect the functioning of the pancreas, which secretes hormones to regulate blood sugar and enzymes to support digestion.  Examples include inflammation, cysts, and fatty stool."
  },
  "10.1": {
    title: "Diseases of the urinary system",
    tooltip:
      "Conditions that affect the urinary system - the organs and processes that balance the body's fluids and electrolytes, manages blood volume, pressure, and pH, and rids the body of waste. Examples include urinary tract infections (UTIs), incontinence, and diseases of the bladder."
  },
  "10.2": {
    title: "Diseases of male genital organs",
    tooltip:
      "Conditions that affect male genital organs including the prostate, penis, and testicles."
  },
  "10.3": {
    title: "Diseases of female genital organs",
    tooltip:
      "Conditions that affect female genital organs including the breasts, uterus, vagina, and ovaries."
  },
  "11.1": {
    title: "Contraceptive and procreative management",
    tooltip:
      "Includes a variety of encounters for management of contraception. Examples include intrauterine device (IUD) insertion, counseling for procreation, and sterilization."
  },
  "11.2": {
    title: "Abortion-related disorders",
    tooltip: "Miscarriage or abortion, as well as any related complications"
  },
  "11.3": {
    title: "Complications mainly related to pregnancy",
    tooltip:
      "Includes a variety of complications or conditions that may arise during pregnancy.  Examples include high blood pressure, hemorrhage, pregnancy taking place outside of the uterus, and early, delayed, or threatened labor."
  },
  "11.4": {
    title: "Indications for care in pregnancy; labor; and delivery",
    tooltip:
      "Includes a variety of effects on the mother or baby observed during pregnancy, labor, or delivery. Examples include insufficient contractions and dilation of the cervix during labor, abnormal positioning of the fetus that can obstruct or prolong delivery, and a mother's scars from a previous cesarean section."
  },
  "11.5": {
    title: "Complications during labor",
    tooltip:
      "Includes complications that arise during labor.  Examples include umbilical cord complications and entanglement, and skin and muscle tears in the vagina or surrounding tissues during labor."
  },
  "11.6": {
    title: "Other complications of birth; puerperium affecting management of mother",
    tooltip:
      "Includes a variety of conditions and complications arising during birth or the postpartum period, affecting the mother, baby, or both. Examples include abnormal fetal heartbeat, bacterial infection passed from the mother's vagina to the newborn during birth, and delivery via cesarean section."
  },
  "11.7": {
    title: "Normal pregnancy and/or delivery",
    tooltip:
      "Includes a variety of pregnancy and delivery conditions, such as normal and multiple births."
  },
  "12.1": {
    title: "Skin and subcutaneous tissue infections",
    tooltip:
      "Infections that affect the various layers of the skin. Examples include bacterial skin infections, boils, and abscesses."
  },
  "12.2": {
    title: "Other inflammatory condition of skin",
    tooltip:
      "Includes a variety of skin conditions that can cause redness, rash, itchiness, dryness, and discomfort.  Examples include psoriasis, sunburn, dermatitis, and rosacea."
  },
  "12.3": {
    title: "Chronic ulcer of skin",
    tooltip:
      "Damage to the skin and potentially underlying tissue due to either poor blood circulation or long-term friction or pressure on the skin (e.g., bed sores). "
  },
  "12.4": {
    title: "Other skin disorders",
    tooltip:
      "Includes a variety of skin disorders, including acne, rash, and pre-cancer rough patches due to sun damage."
  },
  "13.1": {
    title: "Infective arthritis and osteomyelitis (except that caused by TB or STD)",
    tooltip: "A bacterial infection of the bone or joint."
  },
  "13.2": {
    title: "Non-traumatic joint disorders",
    tooltip:
      "Joint conditions that were not caused by trauma, injury, or accident. Examples include osteoarthritis, joint pain caused by the wearing down of cartilage that protects the ends of bones, and rheumatoid arthritis, joint pain caused when the immune system attacks body tissue."
  },
  "13.3": {
    title: "Spondylosis; intervertebral disc disorders; other back problems",
    tooltip: "Arthritis caused by the wear and tear of the body's spinal disks."
  },
  "13.4": {
    title: "Osteoporosis",
    tooltip:
      "A bone disease resulting in loss of bone density and strength. This condition increases a person's risk of fracture or broken bones, even from routine activities."
  },
  "13.5": {
    title: "Pathological fracture",
    tooltip:
      "A broken bone caused by disease, not injury. Conditions like osteoporosis and cancer are among some of the causes."
  },
  "13.6": {
    title: "Acquired deformities",
    tooltip:
      "A change in the normal size or shape of a body part as a result of an injury, infection, arthritis, or tumor."
  },
  "13.7": {
    title: "Systemic lupus erythematosus and connective tissue disorders",
    tooltip:
      "A disease that can cause inflammation of the connective tissue in every organ of the body."
  },
  "13.8": {
    title: "Other connective tissue disease",
    tooltip:
      "Includes a variety of conditions of the connective tissue, including muscles, fascia, ligaments, and tendons.  Examples include bone spurs, inflamed tendons and fascia, calcium buildup in muscles, and fibromyalgia, a disorder that causes widespread muscle pain and fatigue."
  },
  "13.9": {
    title: "Other bone disease and musculoskeletal deformities",
    tooltip:
      "Includes almost 1,000 conditions affecting the body's bones and muscles.  Examples include neck problems and misalignment, a sideways curve in the spine (scoliosis), bone cysts, and bone deterioration due to lack of blood supply, "
  },
  "14.1": {
    title: "Cardiac and circulatory congenital anomalies",
    tooltip:
      "An abnormality in the heart or tissues that circulate blood that is present at birth. Examples include a hole in the wall of the heart's chambers, defective heart vessels, and leaky heart valves."
  },
  "14.2": {
    title: "Digestive congenital anomalies",
    tooltip:
      "Conditions that affect the digestive system at birth or develop shortly after birth. Includes conditions that can impact organs of the gastrointestinal tract from the mouth to the anus, including the esophagus, stomach, and intestines."
  },
  "14.3": {
    title: "Genitourinary congenital anomalies",
    tooltip:
      "Conditions that affect the urinary system or genital organs from birth, or develop shortly after birth."
  },
  "14.4": {
    title: "Nervous system congenital anomalies",
    tooltip:
      "Conditions that affect the brain and nervous system at birth or develop shortly after birth. Examples include malformations of the spine and spinal cord, abnormally small head size in a newborn, and Arnold-Chiari malformation where the lower portion of the brain extends into the spinal canal."
  },
  "14.5": {
    title: "Other congenital anomalies",
    tooltip:
      "Includes a variety of conditions that arise at birth, or develop shortly after. Examples include chromosomal conditions like Down syndrome and craniosynostosis, the premature fusing of the bones in a baby's skull before the brain is fully formed."
  },
  "15.1": {
    title: "Liveborn",
    tooltip: "Infants born alive, demonstrated by a heartbeat, breath, and voluntary movement."
  },
  "15.2": {
    title: "Short gestation; low birth weight; and fetal growth retardation",
    tooltip:
      "Infants born prematurely or underweight. Infants with these conditions have a higher risk of developmental difficulties, health complications, and premature death."
  },
  "15.3": {
    title: "Intrauterine hypoxia and birth asphyxia",
    tooltip:
      "Conditions that occur when a baby does not get enough oxygen before or during the birthing process. This can lead to significant damage to or failure of the lungs, heart, brain, or kidneys."
  },
  "15.4": {
    title: "Respiratory distress syndrome",
    tooltip:
      "A condition that impacts a newborn's lungs and affects the body's ability to breathe in enough oxygen to support the body's organs. It is more common among premature infants."
  },
  "15.5": {
    title: "Hemolytic jaundice and perinatal jaundice",
    tooltip:
      "A condition that impacts newborns where the liver is not correctly processing bilirubin, a yellow pigment created in the normal breakdown of red blood cells."
  },
  "15.6": {
    title: "Birth trauma",
    tooltip:
      "Injuries and conditions resulting from complications at birth, often due to excessive force used during the delivery of a baby."
  },
  "15.7": {
    title: "Other perinatal conditions",
    tooltip:
      "Includes a variety of other conditions arising in newborns, such as abnormally low blood sugar or paused breathing"
  },
  "16.1": {
    title: "Joint disorders and dislocations; trauma-related",
    tooltip:
      "Conditions in which injuries cause the body's joints to become displaced from their usual position, or the joint tissues become torn or separated. Common joints affected include the knee, hip, elbow, shoulder, fingers, and jaw. "
  },
  "16.10": {
    title: "Complications",
    tooltip:
      "Includes over 2,000 complications from surgical procedures, medical care, devices, implant or grafts."
  },
  "16.11": {
    title: "Poisoning",
    tooltip:
      "Exposure to a substance that can harm the body and potentially cause death, such as psychotropic agents that change the behavior of the nervous system (e.g., antidepressants), medications, and nonmedicinal substances (e.g., cleaning products, cosmetics and personal care products)."
  },
  "16.12": {
    title: "Other injuries and conditions due to external causes",
    tooltip:
      "A wide range of injuries, including those affecting a variety of nerves, muscles, fascia, and tendons, as well as the ear, head, nose, face, neck, vocal cord, spine. "
  },
  "16.2": {
    title: "Fractures",
    tooltip: "Broken bones, including stress fractures, partial breaks, and complete breaks"
  },
  "16.3": {
    title: "Spinal cord injury",
    tooltip:
      "Damage to the spinal cord, a major part of the central nervous system that passes messages between the brain and the rest of the body, which can result in partial or complete loss of sensation and mobility in various parts of the body depending on the site of the injury."
  },
  "16.4": {
    title: "Intracranial injury",
    tooltip:
      "Injury within the skull that can result in both physical and psychological effects.  Examples include concussions, brain swelling and inflammation, and brain hemorrhages."
  },
  "16.5": {
    title: "Crushing injury or internal injury",
    tooltip:
      "Bruising, tears, cuts, excessive pressure, or other injury that damages an organ or tissue."
  },
  "16.6": {
    title: "Open wounds",
    tooltip: "A break in the skin that exposes internal issue"
  },
  "16.7": {
    title: "Sprains and strains",
    tooltip:
      "A sprain occurs when a ligament, the tissue that connects bones, is torn or stretched.  A strain occurs when a muscle or tendon is torn or stretched."
  },
  "16.8": {
    title: "Superficial injury; contusion",
    tooltip:
      "Bruising that appears when blood vessels leak blood into the surrounding area of an injury"
  },
  "16.9": {
    title: "Burns",
    tooltip:
      "Severe damage to the skin. Common causes include hot boiling liquids, chemicals, electricity, fires, and excessive sun exposure. Some burn damage can extend beyond skin into tendons and bones."
  },
  "17.1": {
    title: "Symptoms; signs; and ill-defined conditions",
    tooltip:
      "Typically conditions for which a diagnostic workup is still taking place before making a diagnosis (e.g., symptoms of fainting, fever, or enlarged lymph nodes are present, but lab tests and radiology need to be done).  Often includes "
  },
  "17.2": {
    title: "Factors influencing health care",
    tooltip:
      "Includes diagnosis codes for general medical exams, screenings, preventive health, and equipment."
  },
  "18.1": {
    title: "Unclassified conditions",
    tooltip: `Includes over 7,000 diagnosis codes that describe some clinical conditions like sleep disorders and adverse effects of medical drugs, as well as "cause codes" that outline additional details regarding the development of an injury or condition (e.g., place of occurrence, whether someone was struck by an object, caused by a transportation accident, exposure to the natural environment, firearms, burns, poison, falling)`
  }
};

export const MEDICAL_CLINICAL_COPY_FIELDS = {
  TITLE: "title",
  SHORT_NAME: "shortName",
  TOOLTIP: "tooltip"
};

export const SERVICE_TYPE_SHORTHAND = {
  Inpatient: "IP",
  Outpatient: "OP",
  Professional: "PR"
};
